export default __webpack_public_path__ + "static/media/inventory.0481811f.png";